import { Injectable, signal } from '@angular/core';
import { INotification } from './notification.interface';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    public showNotification = signal<boolean>(false);
    public notification = signal<INotification>(null);

    public addNotification(notification: INotification): void {
        this.notification.set(notification);
        this.showNotification.set(true);
        setTimeout(() => {
            this.showNotification.set(false);
            this.notification.set(null);
        }, notification?.duration || 5000);
    }
}
